// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"40c78961","455":"bb6f7c7f","977":"7fd685de"}[chunkId] + ".chunk.js";
};